module.exports = __webpack_public_path__ + "static/scale-model-of-real-escape-bakersfield-in-bakersfield-california-29bcfd1c57fbb69616e2beea874a629a.png";